import { computed } from 'vue';

/**
 * Shared state for Contact Form groups mode (MP-2260).
 * Set by fetchOrganizations after probing the public groups API or receiving 403.
 */
export const useContactFormGroupsMode = () => {
  const customGroupsEnabled = useState<boolean | null>('contactForm.customGroupsEnabled', () => null);

  const useCustomGroups = computed(() => customGroupsEnabled.value !== false);

  const setCustomGroupsEnabled = (value: boolean) => {
    customGroupsEnabled.value = value;
  };

  return {
    customGroupsEnabled,
    useCustomGroups,
    setCustomGroupsEnabled,
  };
};
